const firebaseConfig = {
    apiKey: "AIzaSyD2IBLAs9KP1eCZu4837mbBCPy5K_4zSe0",
    authDomain: "around-the-world-502d4.firebaseapp.com",
    projectId: "around-the-world-502d4",
    storageBucket: "around-the-world-502d4.appspot.com",
    messagingSenderId: "983376654243",
    appId: "1:983376654243:web:cf401764c81e21db13f416"
  };

export default firebaseConfig;
